"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class ZoneClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'zones';
    }
    createZones(projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/zones`, payload);
            return response.payload;
        });
    }
    updateZone(projectId, zoneId, requestPayload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zones/${zoneId}`;
            const response = yield this.httpPut(url, requestPayload);
            return response.payload;
        });
    }
    updateZones(projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/zones`, payload);
            return response.payload;
        });
    }
    deleteZones(projectId, zoneIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zones?${this.getQueryString({ zoneIds })}`;
            return this.httpDelete(url);
        });
    }
    getZone(projectId, id, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zones/${id}?${this.getQueryString({ fields })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getAutoZonesPOC(projectId, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zones/auto-zone-poc`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
}
exports.ZoneClient = ZoneClient;
//# sourceMappingURL=zone.client.js.map